import { Box, FormHelperText } from "@mui/material";
import { FC, useCallback, useState } from "react";
import { useTitlePage } from "../../hooks/use-title-page";
import { FirebaseError } from "firebase/app";
import { deleteUser } from "firebase/auth";
import { auth } from "../../firebase";
import { Delete } from "@mui/icons-material";
import ButtonLoading from "../../components/helpers/ButtonLoading";
import { MainContentWrapper } from "../../layouts/base/MainContentWrapper";
import { MainContentHeader } from "../../layouts/base/MainContentHeader";
const title = "מחיקת החשבון שלי";
const DeleteMyAccountPage: FC = () => {
  useTitlePage(title);

  const [errorMessage, setErrorMessage] = useState("");

  const deleteMyAccount = useCallback(async () => {
    try {
      setErrorMessage("");
      await deleteUser(auth.currentUser!);
    } catch (error) {
      if (error instanceof FirebaseError) {
        console.error(error);
        setErrorMessage(error.message);
      } else {
        console.error(error);
        setErrorMessage("Error occurred while deleting your account");
      }
    }
  }, []);

  return (
    <MainContentWrapper>
      <MainContentHeader title={title} />
      <Box>
        <ButtonLoading
          size="large"
          sx={{ mt: 3 }}
          variant="contained"
          btnText="מחיקת החשבון שלי"
          loadingText="מוחק..."
          onClick={deleteMyAccount}
          btnIcon={<Delete />}
        />
      </Box>
      {!!errorMessage && (
        <FormHelperText error sx={{ mt: 3 }}>
          {errorMessage}
        </FormHelperText>
      )}
    </MainContentWrapper>
  );
};

export default DeleteMyAccountPage;
